<div class="uni-flex uni-justify-space-between uni-align-center item">
  @if (item.href) {
    <a [routerLink]="item.href">{{ item.displayValue }}</a>
  } @else {
    <div class="details">{{ item.displayValue }}</div>
  }

  @if (item.entityName) {
    <div class="type">
      <mat-chip>{{ item.entityName }}</mat-chip>
    </div>
  }
</div>
